export default "__VITE_ASSET__0810a307__"